// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8090) return "static/chunks/11e5bce3-4b94995e17d49a95.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "e27a62a0e56d832f" + ".js";
};